import gql from 'graphql-tag';

const VALIDATE_SALES_TRIAL_CREDENTIALS = gql`
  query ValidateSalesTrialCredentials($email: String!, $code: String!, $page_url: String!) {
    validateSalesTrialCredentials(email: $email, code: $code, page_url: $page_url) {
      valid
      expirationDate
    }
  }
`;

const SALES_TRIAL_LESSON_TOKEN = gql`
  query SalesTrialLessonToken(
    $lesson_id: Int!
    $sales_potential_company_id: Int!
    $hash_code: String!
    $user: Int!
  ) {
    salesTrialLessonToken(
      lesson_id: $lesson_id
      sales_potential_company_id: $sales_potential_company_id
      hash_code: $hash_code
      user: $user
    ) {
      token
    }
  }
`;

const SALES_TRIAL_LESSON_LIST = gql`
  query SalesTrialLessonList($page_url: String!, $code: String!, $email: String!) {
    salesTrialLessonList(page_url: $page_url, code: $code, email: $email) {
      items {
        id
        url_student_a
        url_student_b
        from
        to
      }
    }
  }
`;

const SALES_TRIAL_HTML_MATERIAL = gql`
  query SalesTrialHtmlMaterial($lesson_id: Int!, $rank_id: Int!, $k: String!, $v: String!) {
    salesTrialHtmlMaterial(lesson_id: $lesson_id, rank_id: $rank_id, k: $k, v: $v) {
      id
      program_id
      level_id
      rank_id
      lesson_id
      code
      no
      title
      program
      level
      rank
      css
      content
      pdf_url
      html_url
      is_revamp
      admin
    }
  }
`;

const SALES_TRIAL_USEFUL_PHRASES = gql`
  query SalesTrialUsefulPhrases($token: String!) {
    salesTrialUsefulPhrases(token: $token) {
      items {
        category_id
        description
        phrases {
          phrase_id
          phrase_en
          phrase_ja
        }
      }
    }
  }
`;

const SALES_TRIAL_PDF = gql`
  query SalesTrialPdf($m: Int!) {
    salesTrialPdf(m: $m) {
      id
      type
      url
    }
  }
`;

const SALES_TRIAL_MATERIALS = gql`
  query SalesTrialMaterials($k: String!, $v: String!) {
    salesTrialMaterials(k: $k, v: $v) {
      ri
      lv
      rk
      rt
      mt
      rv
      ls {
        li
        ln
        lc
        lt
        ti
        vi
        mi
        hh
        rv
      }
    }
  }
`;

export {
  VALIDATE_SALES_TRIAL_CREDENTIALS,
  SALES_TRIAL_LESSON_TOKEN,
  SALES_TRIAL_LESSON_LIST,
  SALES_TRIAL_USEFUL_PHRASES,
  SALES_TRIAL_PDF,
  SALES_TRIAL_MATERIALS,
  SALES_TRIAL_HTML_MATERIAL
};
